import classNames from 'classnames'

import { ICON_HEIGHT_24 } from '../../Icon'
import { FileIcon } from '../FileIcon'
import { FILE_ICON_COLOR } from '../FileIcon.constants'
import { getFileIconType } from '../FileIcon.utils'

import {
  FILE_ICON_PLACEHOLDER_BACKGROUND_COLOR,
  FILE_ICON_PLACEHOLDER_SIZE,
} from './FileIconPlaceholder.constants'
import { getFileIconPlaceholderOpacity } from './FileIconPlaceholder.utils'

import * as styles from './FileIconPlaceholder.module.css'

function FileIconPlaceholder({
  className = styles.fileIconPlaceholder,
  file,
  getIconType = getFileIconType,
  size = ICON_HEIGHT_24,
  type,
  ...restProps
}) {
  const fileType = type || getIconType(file)

  const backgroundOpacity = getFileIconPlaceholderOpacity(
    fileType,
    FILE_ICON_COLOR[fileType]
  )

  return (
    <FileIcon
      {...restProps}
      className={classNames(className, {
        [styles[`size${size}`]]: size,
      })}
      size={FILE_ICON_PLACEHOLDER_SIZE[size]}
      style={{
        '--file-icon-placeholder-background-color':
          FILE_ICON_PLACEHOLDER_BACKGROUND_COLOR[fileType],
        '--file-icon-placeholder-background-opacity': backgroundOpacity,
      }}
      type={fileType}
    />
  )
}

export default FileIconPlaceholder
